import React from "react";

import MuiMenu, { MenuProps as MuiMenuProps } from "@mui/material/Menu";
import styled from "@mui/material/styles/styled";

import { MenuTitle } from "./styles";

export interface MenuProps extends MuiMenuProps {
  disablePadding?: boolean;
  padding?: React.CSSProperties["padding"];
  title?: string;
}

const Menu = styled<React.FC<MenuProps>>(
  ({ disablePadding: _dp, padding: _d, title, children, ...props }) => {
    return (
      <MuiMenu {...props}>
        {title && <MenuTitle>{title}</MenuTitle>}
        {children}
      </MuiMenu>
    );
  }
)(({ disablePadding, padding, theme }) => ({
  "& .MuiList-root": {
    padding: padding ?? (disablePadding ? 0 : "12px"),
  },

  "& .MuiButtonBase-root.MuiMenuItem-root+.MuiDivider-root": {
    marginTop: "4px",
    marginBottom: "4px",
    borderBottomColor: theme.palette.shades.neutral[50],
  },
}));

export default Menu;
